import { Injectable, Type } from '@angular/core';
import { GungTroubleshootingBaseViewComponent } from '../../components/gung-troubleshooting/gung-troubleshooting-base-view/gung-troubleshooting-base-view.component';
import { GungTroubleshootingProductViewComponent } from '../../components/gung-troubleshooting/gung-troubleshooting-product-view/gung-troubleshooting-product-view.component';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GungFlow } from '../../state/flow/types';
import { Availability } from '../../models/availability';
import { Product } from '../../models/product';
import { User } from '../../state/auth/types';

export interface GungTroubleshootingMenuItem {
  id: string;
  name: string;
  component: Type<GungTroubleshootingBaseViewComponent> | undefined;
  icon?: string;
}

export interface GungTroubleshootingProductDebug {
  isInAssortment: boolean,
  isProductBlocked: boolean,
  flow: {
    currentAvailability: number,
    isProductInFlow: boolean,
    requireAvailability: boolean,
    requireCurrentAvailability: boolean
  },
  data: {
    availability: Availability,
    flow: GungFlow,
    product: Product,
    user: User
  },
  error?: string
}

@Injectable({
  providedIn: 'root'
})
export class GungTroubleshootingService {
  protected baseUrl: string = 'json/debug/';

  constructor(
    protected http: HttpClient
  ) {}

  public getGungTroubleshootingMenu(): Observable<GungTroubleshootingMenuItem[]> {
    const menu: GungTroubleshootingMenuItem[] = [];

    menu.push({
      id: 'TROUBLESHOOTING_PRODUCT',
      name: 'PRODUCT',
      icon: 'fa-light fa-box',
      component: GungTroubleshootingProductViewComponent
    });

    return of(menu);
  }

  public debugProduct(productId: string, username: string, flowId: string): Observable<GungTroubleshootingProductDebug> {
    return this.http.get<GungTroubleshootingProductDebug>(this.baseUrl + `product-not-showing?productId=${productId}&userId=${username}&flowId=${flowId}`);
  }

  public getErpSpecificProductBlockedTranslateTag(): string {
    return '';
  }
}
